import { Alert, Button } from "@mui/material";
import BotaoRelatorioIndicador from "./BotaoRelatorioIndicador";
import DropDownExports from "../DropDownExports";

export default function BotoesFiltro({ filterOnClick, laudos, apontamentosPorTipo, filters, agrupadoresRel, msgFilter, }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 15, flexWrap: "wrap", }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-around", gap: 15, flexWrap: "wrap", }}>
                <Button onClick={filterOnClick} style={{ whiteSpace: "noWrap", minWidth: "auto", }}>
                    Filtrar
                </Button>
                {laudos?.length
                    ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 15, flexWrap: "wrap", }}>
                            <BotaoRelatorioIndicador
                                laudos={laudos}
                                apontamentosPorTipo={apontamentosPorTipo}
                                detalhaApontamentos={filters.detalhaApontamentos}
                                cliente={filters.cliente}
                                agrupador={agrupadoresRel[agrupadoresRel.map((t) => t.nome).indexOf(filters.agrupador)]}
                                filters={filters}
                            />
                            <DropDownExports laudos={laudos} />
                            {/* <Button variant="contained" color="primary" startIcon={<ShareIcon />} onClick={handleShare}>Compartilhar no WhatsApp</Button> */}
                        </div>
                    )
                    : null
                }
            </div>
            {msgFilter ? <Alert severity="warning">{msgFilter}</Alert> : msgFilter}
        </div>
    );
}
